/* ============================================================
   Torshi × BundleSuite — integration glue
   The app embed's custom_section_class is set to
   "torshi-builder-mount" (settings_data.json), so the native PDP
   stays intact and the builder mounts into the div this script
   creates right below it. Loaded only on bundle-builder pages
   (see theme.liquid).
   ============================================================ */
(function () {
  'use strict';

  var MOUNT_CLASS = 'torshi-builder-mount';

  /* Create the builder mount right after the main product section.
     This file is deferred, so it runs after DOM parse but before
     DOMContentLoaded handlers — i.e. before the app looks for it. */
  function ensureMount() {
    if (document.querySelector('.' + MOUNT_CLASS)) return false;
    var main = document.querySelector('.main-product-section');
    if (!main) return false;
    var div = document.createElement('div');
    div.className = MOUNT_CLASS;
    main.after(div);
    return true;
  }
  ensureMount();

  /* The placeholder product is $0.00 — swap the hidden native price
     row for per-jar pricing. */
  function patchPdp() {
    var priceRow = document.querySelector('.main-product-section .product__price');
    if (priceRow && !document.querySelector('.torshi-price-line')) {
      var line = document.createElement('div');
      line.className = 'torshi-price-line';
      line.innerHTML = 'From <strong>$10.00</strong> / jar <span class="torshi-save-chip">Save up to 20%</span>';
      priceRow.insertAdjacentElement('afterend', line);
    }
  }

  function patchButtons() {
    document.querySelectorAll('#bundlesuiteContainer .add-button').forEach(function (btn) {
      if (btn.getAttribute('data-stock-status') === 'in-stock' && btn.textContent.trim() === 'Add to Cart') {
        btn.textContent = 'Add to Box';
      }
    });
  }

  /* The PDP heading block introduces both paths: preset or custom.
     The compact preset card is injected right after it. */
  function findCustomizeBlock() {
    var meta = document.querySelector('.main-product-section .product__meta');
    if (!meta) return null;
    var blocks = meta.querySelectorAll(':scope > .product__block');
    for (var i = 0; i < blocks.length; i++) {
      var t = blocks[i].textContent;
      if (t.indexOf('Customize your box below') > -1 || t.indexOf('Select the most popular') > -1) {
        return blocks[i];
      }
    }
    return null;
  }
  function patchCustomizeHeading() {
    var block = findCustomizeBlock();
    if (!block) return;
    var h = block.querySelector('h3');
    if (h && h.textContent.indexOf('Customize your box below') > -1) {
      h.innerHTML = '<strong>Select the most popular or customize your box👇</strong>';
    }
  }

  /* There is only one set — drop the "from Set 1" suffix the app
     appends to the section heading. */
  function patchSectionTitles() {
    document.querySelectorAll('#bundlesuiteContainer .section-title').forEach(function (h) {
      var t = h.textContent;
      var stripped = t.replace(/\s*from Set\s*\d+\s*$/i, '');
      if (stripped !== t) h.textContent = stripped;
    });
  }

  /* Cart stepper copy clean-up:
     - "Fixed price $120.00" ×4 can never fit on one line — trim to the
       price alone.
     - Percentage tiers come out of the app at full float precision
       ("11.11111111% OFF") — round them to whole numbers.
     The untouched original is kept in data-torshi-raw so getTiers()
     keeps doing the pricing math on the exact value. */
  function tidyTierValue(text) {
    var fixed = text.match(/^\s*Fixed price\s*(\$[\d,.]+)\s*$/i);
    if (fixed) return fixed[1];
    var pct = text.match(/^\s*([\d.]+)\s*%\s*(OFF)?\s*$/i);
    if (pct) return Math.round(parseFloat(pct[1])) + '%' + (pct[2] ? ' OFF' : '');
    return null;
  }
  function patchStepperLabels() {
    /* both stepper copies the app renders — the cart one and the
       (currently hidden) in-content one */
    document.querySelectorAll('#bundlesuiteContainer .discount-stepper-item .discount-value p').forEach(function (p) {
      var txt = p.textContent;
      var out = tidyTierValue(txt);
      if (out !== null && out !== txt) {
        p.setAttribute('data-torshi-raw', txt);
        p.textContent = out;
      }
    });
    /* progress banner: "Add 3 items more to get 11.11111111% OFF" */
    document.querySelectorAll('#bundlesuiteContainer .discount-info-container-header h3').forEach(function (h) {
      var txt = h.textContent;
      var out = txt.replace(/(\d+\.\d+)\s*%/g, function (_, n) { return Math.round(parseFloat(n)) + '%'; });
      if (out !== txt) h.textContent = out;
    });
    /* one-line caption so the tier strip explains itself. Fixed-box
       mode needs no caption — the box cards carry their own prices and
       the app prints "Add N more item(s) to fill your box" underneath. */
    document.querySelectorAll('#bundlesuiteContainer .side-cart-stepper .discount-stepper').forEach(function (strip) {
      if (strip.classList.contains('boxed-discount-stepper')) {
        /* the app can render a plain strip first and swap in the boxed
           one — drop a caption left behind by that first render */
        var stale = strip.nextElementSibling;
        if (stale && stale.classList.contains('torshi-stepper-caption')) stale.remove();
        return;
      }
      var next = strip.nextElementSibling;
      if (next && next.classList.contains('torshi-stepper-caption')) return;
      var cap = document.createElement('p');
      cap.className = 'torshi-stepper-caption';
      cap.textContent = 'Add more items to get this much off';
      strip.parentNode.insertBefore(cap, strip.nextSibling);
    });
  }

  /* Fixed-box cards ship with the box price only ("$75.00"), which hides
     the whole offer. Show what the jars cost loose (size × jar price)
     struck through, with the box price next to it — same language as the
     Classic 6 card. The data attributes the pricing math reads are left
     untouched; only the visible text is rewritten. */
  function money(n) {
    return '$' + n.toFixed(2);
  }
  function jarPrice() {
    var cards = inStockCards();
    if (!cards.length) return 0;
    var t = ((cards[0].querySelector('.product-price p') || {}).textContent || '');
    return parseFloat(t.replace(/[^\d.]/g, '')) || 0;
  }
  function patchBoxOptions() {
    var stepper = document.querySelector('#bundlesuiteContainer .side-cart-stepper');
    if (stepper) {
      stepper.classList.toggle('torshi-boxed',
        !!stepper.querySelector('.boxed-discount-stepper'));
    }
    var jar = jarPrice();
    document.querySelectorAll('#bundlesuiteContainer .box-options-container .box-option[data-box-size]')
      .forEach(function (opt) {
        var size = parseInt(opt.getAttribute('data-box-size'), 10);
        var cents = parseInt(opt.getAttribute('data-box-price'), 10);
        if (!(size > 0) || !(cents > 0)) return;
        /* the preset box is the hero — CSS hangs the "Best Seller" pill
           off whatever card carries this class */
        opt.classList.toggle('torshi-box-hero', size === PRESET_SIZE);
        var priceEl = opt.querySelector('.box-price');
        if (!priceEl) return;
        var list = jar * size;
        var now = cents / 100;
        var html = (jar > 0 && list > now)
          ? '<s>' + money(list) + '</s><span class="torshi-box-now">' + money(now) + '</span>'
          : '<span class="torshi-box-now">' + money(now) + '</span>';
        if (priceEl.innerHTML !== html) priceEl.innerHTML = html;
      });
  }

  /* Mobile opens on a bare product photo — title, price and the
     free-shipping badge sit below the fold. Move that intro block above
     the gallery on small screens so the page leads with what it is.
     Fully reversible: on desktop widths the blocks go back to their
     original spot in the right column (markers remember where), so
     resizing the window never leaves the layout distorted. */
  var torshiHeadMq = window.matchMedia('(max-width: 959px)');
  function relocateMobileHeader() {
    var wrap = document.querySelector('.torshi-mobile-head');
    if (torshiHeadMq.matches) {
      if (wrap) return;
      var primary = document.querySelector('.main-product-section .product__primary');
      var meta = document.querySelector('.main-product-section .product__meta');
      if (!primary || !meta) return;
      var header = meta.querySelector(':scope > .product__block--header') ||
                   (meta.querySelector('h1') && meta.querySelector('h1').closest('.product__block'));
      if (!header || !header.querySelector('.torshi-price-line')) return; /* wait for the price line */
      var callout = meta.querySelector(':scope > .product__block-callouts-mini');
      wrap = document.createElement('div');
      wrap.className = 'torshi-mobile-head';
      primary.insertBefore(wrap, primary.firstChild);
      [header, callout].forEach(function (block) {
        if (!block) return;
        if (!block.torshiHomeMarker) {
          var m = document.createElement('div');
          m.style.display = 'none';
          block.parentNode.insertBefore(m, block);
          block.torshiHomeMarker = m;
        }
        wrap.appendChild(block);
      });
    } else if (wrap) {
      [].slice.call(wrap.children).forEach(function (block) {
        var m = block.torshiHomeMarker;
        if (m && m.parentNode) m.parentNode.insertBefore(block, m.nextSibling);
      });
      wrap.remove();
    }
  }
  torshiHeadMq.addEventListener('change', relocateMobileHeader);

  /* ---- "Fill it with our favourites" — one-tap autofill ----
     Lives in the cart under the box-size picker. Fills the REMAINING
     slots of the selected box with the recommended mix (one of each
     in-stock flavour, extras round-robin on bestsellers) — it tops up
     around whatever the customer already picked, it never clears.
     Uses the app's own add/plus buttons, so cart, counter and pricing
     stay in sync and the jars animate into their slots one by one. */
  var AUTOFILL_LABEL = '\u2728 Fill it with our favourites';
  var autofillBusy = false;

  function boxState() {
    var sel = document.querySelector('#bundlesuiteContainer .side-cart-stepper .box-options-container .box-option.selected');
    var size = sel ? parseInt(sel.getAttribute('data-box-size'), 10) : 0;
    var count = parseInt((document.querySelector('#bundlesuiteContainer .added-products-count') || {}).textContent, 10) || 0;
    return { size: size, count: count };
  }

  function ensureAutofill() {
    var stepper = document.querySelector('#bundlesuiteContainer .side-cart-stepper');
    if (!stepper) return;
    var btn = stepper.querySelector('.torshi-autofill');
    if (!stepper.querySelector('.boxed-discount-stepper')) { if (btn) btn.remove(); return; }
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'torshi-autofill';
      btn.textContent = AUTOFILL_LABEL;
      btn.addEventListener('click', function () { runAutofill(btn); });
      stepper.appendChild(btn);
    }
    if (!autofillBusy) {
      var st = boxState();
      var show = st.size > 0 && st.count < st.size;
      btn.style.display = show ? '' : 'none';
      if (show && btn.textContent !== AUTOFILL_LABEL) btn.textContent = AUTOFILL_LABEL;
    }
  }

  function runAutofill(btn) {
    if (autofillBusy || presetBusy) return;
    var st = boxState();
    var need = st.size - st.count;
    var cards = inStockCards();
    if (need <= 0 || !cards.length) return;
    /* target composition for this box size: one of each, extras
       round-robin in card order (bestsellers first) */
    var hs = cards.map(function (c) { return c.getAttribute('data-product-handle'); });
    var target = {};
    hs.forEach(function (h) { target[h] = 0; });
    for (var i = 0; i < st.size; i++) target[hs[i % hs.length]] += 1;
    var steps = [];
    cards.forEach(function (c) {
      var h = c.getAttribute('data-product-handle');
      var qc = c.querySelector('.quantity-controls');
      var input = c.querySelector('.quantity-input');
      var cur = (qc && getComputedStyle(qc).display !== 'none' && input) ? (parseInt(input.value, 10) || 0) : 0;
      for (var k = cur; k < target[h]; k++) steps.push(h);
    });
    steps = steps.slice(0, need);
    var j = 0; /* customer over-picked some flavour — top up with the rest */
    while (steps.length < need) { steps.push(hs[j % hs.length]); j += 1; }
    autofillBusy = true;
    btn.disabled = true;
    allowCart();
    var total = need, done = 0;
    (function tick() {
      if (!steps.length) {
        btn.textContent = '\u2713 Packed with our favourites';
        btn.disabled = false;
        autofillBusy = false;
        ensureAutofill();
        return;
      }
      var card = cardByHandle(steps.shift());
      if (card) {
        var add = card.querySelector('.add-button');
        if (add && getComputedStyle(add).display !== 'none') add.click();
        else { var p = card.querySelector('.quantity-btn.plus'); if (p) p.click(); }
        done += 1;
        btn.textContent = 'Packing your box\u2026 ' + done + '/' + total;
      }
      setTimeout(tick, 550);
    })();
  }

  /* The widget cart (desktop side column / mobile bottom sheet) stays
     hidden until it is actually useful: the customer opened the
     customizer, finished the preset, or already has items in the box. */
  function allowCart() {
    var c = document.getElementById('bundlesuiteContainer');
    if (c) c.classList.add('torshi-cart-allowed');
  }
  function syncCartAllowed() {
    var count = document.querySelector('#bundlesuiteContainer .added-products-count');
    if (count && parseInt(count.textContent, 10) > 0) allowCart();
  }

  /* Reorder: "★ Torshi at a Glance" (+ its checklist and closing
     paragraph) and the FAQ accordions move below the builder, in that
     order. Runs late (once the widget exists) so the theme has already
     bound the accordion toggles. */
  function relocateBelowBuilder() {
    var meta = document.querySelector('.main-product-section .product__meta');
    var mount = document.querySelector('.' + MOUNT_CLASS);
    if (!meta || !mount) return;

    var anchor = mount;

    /* 1. Torshi at a Glance block group */
    var glanceWrap = document.querySelector('.torshi-glance-relocated');
    if (!glanceWrap) {
      var start = null;
      var kids = meta.children;
      for (var i = 0; i < kids.length; i++) {
        var cls = (kids[i].className || '').toString();
        if (cls.indexOf('product__block') > -1 && kids[i].textContent.indexOf('Torshi at a Glance') > -1) {
          start = kids[i];
          break;
        }
      }
      if (start) {
        var toMove = [start];
        var n = start.nextElementSibling;
        while (
          n &&
          (n.className || '').toString().indexOf('product__block') > -1 &&
          n.textContent.indexOf('Adding product') === -1
        ) {
          toMove.push(n);
          n = n.nextElementSibling;
        }
        glanceWrap = document.createElement('div');
        glanceWrap.className = 'torshi-glance-relocated';
        toMove.forEach(function (b) {
          glanceWrap.appendChild(b);
        });
        anchor.after(glanceWrap);
      }
    }
    if (glanceWrap) anchor = glanceWrap;

    /* 2. FAQ accordions */
    if (!document.querySelector('.torshi-faq-relocated')) {
      var accs = meta.querySelectorAll(':scope > .accordion');
      if (accs.length) {
        var faqWrap = document.createElement('div');
        faqWrap.className = 'torshi-faq-relocated';
        var heading = document.createElement('h3');
        heading.className = 'torshi-faq-heading';
        heading.textContent = 'Common Questions';
        faqWrap.appendChild(heading);
        accs.forEach(function (a) {
          faqWrap.appendChild(a);
        });
        anchor.after(faqWrap);
      }
    }
  }

  /* ============================================================
     "Most Popular" preset (one-click pre-built box)
     Lives inside the PDP right column, right under the
     "Select the most popular or customize your box👇" heading.
     Composition: one of each in-stock flavour, extras distributed
     from the top of the list until PRESET_SIZE jars. Adding is done
     through the app's own card buttons, so the tier discount, cart
     and checkout all behave exactly as if the customer clicked.
     Arm A (default): product grid starts collapsed behind
     "customize your own". Arm B (?arm=open): grid starts open.
     ============================================================ */
  var PRESET_SIZE = 6;
  var presetBusy = false;

  function getTiers() {
    /* Parsed from the cart stepper. Supports both tier styles the app
       offers: percentage ("15% OFF") and fixed price ("Fixed price
       $75.00"). [{min, pct, fixed}] */
    var tiers = [];
    document.querySelectorAll('#bundlesuiteContainer .side-cart-stepper .discount-stepper-item').forEach(function (item) {
      var th = item.querySelector('.threshold-count');
      var val = item.querySelector('.discount-value p');
      if (th && val) {
        var text = val.getAttribute('data-torshi-raw') || val.textContent;
        var pctMatch = text.match(/([\d.]+)\s*%/);
        var fixedMatch = text.match(/\$\s*([\d,]+(?:\.\d+)?)/);
        tiers.push({
          min: parseInt(th.textContent, 10),
          pct: pctMatch ? parseFloat(pctMatch[1]) : 0,
          fixed: !pctMatch && fixedMatch ? parseFloat(fixedMatch[1].replace(/,/g, '')) : 0
        });
      }
    });
    /* Fixed-box mode ("Sell as fixed boxes") renders box cards instead
       of a tier stepper: 3 items / $40, 6 / $75, 12 / $119.99. Each
       card carries its size and price in cents as data attributes. */
    if (!tiers.length) {
      var seen = {};
      document.querySelectorAll('#bundlesuiteContainer .box-option').forEach(function (b) {
        var size = parseInt(b.getAttribute('data-box-size'), 10);
        var cents = parseInt(b.getAttribute('data-box-price'), 10);
        if (!(size > 0) || !(cents > 0) || seen[size]) return;
        seen[size] = 1;
        tiers.push({ min: size, pct: 0, fixed: cents / 100 });
      });
    }
    tiers.sort(function (a, b) { return a.min - b.min; });
    return tiers;
  }

  function tiersReady() {
    return getTiers().some(function (t) { return t.pct > 0 || t.fixed > 0; });
  }

  function dealForCount(count, subtotal) {
    /* returns {price, savingsPct} for a box of `count` jars */
    var best = null;
    getTiers().forEach(function (t) { if (count >= t.min) best = t; });
    if (best && best.pct > 0) {
      return { price: subtotal * (1 - best.pct / 100), savingsPct: Math.round(best.pct) };
    }
    if (best && best.fixed > 0 && best.fixed < subtotal) {
      return { price: best.fixed, savingsPct: Math.round((1 - best.fixed / subtotal) * 100) };
    }
    return { price: subtotal, savingsPct: 0 };
  }

  function inStockCards() {
    return [].slice.call(
      document.querySelectorAll('#bundlesuiteContainer .product-card')
    ).filter(function (c) {
      var b = c.querySelector('.add-button');
      return b && b.getAttribute('data-stock-status') === 'in-stock';
    });
  }

  function presetPlan() {
    // returns [{handle, qty, title, price}] — one of each, extras round-robin
    var cards = inStockCards();
    if (!cards.length) return [];
    var plan = cards.slice(0, PRESET_SIZE).map(function (c) {
      return {
        handle: c.getAttribute('data-product-handle'),
        title: (c.querySelector('.product-title h4') || {}).textContent || '',
        price: parseFloat(((c.querySelector('.product-price p') || {}).textContent || '').replace(/[^\d.]/g, '')) || 0,
        qty: 1
      };
    });
    var total = plan.length;
    var i = 0;
    while (total < PRESET_SIZE && plan.length) {
      plan[i % plan.length].qty += 1;
      total += 1;
      i += 1;
    }
    return plan;
  }

  function cardByHandle(handle) {
    return document.querySelector('#bundlesuiteContainer .product-card[data-product-handle="' + handle + '"]');
  }

  /* Flag the bestselling flavour in the picker grid. Keyed on the
     handle, with a title fallback so renaming the product in Shopify
     doesn't silently drop the badge. The pill itself is CSS. */
  var POPULAR_HANDLE = 'torshi-500-ml';       // Mixed Vegetable Torshi (500 ml)
  var POPULAR_TITLE = /mixed\s*vegetable/i;

  function markPopularCard() {
    var container = document.getElementById('bundlesuiteContainer');
    if (!container) return;
    var card = cardByHandle(POPULAR_HANDLE);
    if (!card) {
      var cards = container.querySelectorAll('.product-card');
      for (var i = 0; i < cards.length; i++) {
        var t = cards[i].querySelector('.product-title h4');
        if (t && POPULAR_TITLE.test(t.textContent)) { card = cards[i]; break; }
      }
    }
    if (card && !card.classList.contains('torshi-pop')) card.classList.add('torshi-pop');
  }

  /* Empty the box through the app's own minus buttons, one unit at a
     time, so the cart, the box-fill counter and the discount all stay
     in sync. Bounded, so a stuck card can never spin forever. */
  function clearBox(done, guard) {
    guard = guard || 0;
    if (guard > 60) { done(); return; }
    var card = null;
    var cards = document.querySelectorAll('#bundlesuiteContainer .product-card');
    for (var i = 0; i < cards.length; i++) {
      var input = cards[i].querySelector('.quantity-input');
      var qc = cards[i].querySelector('.quantity-controls');
      if (input && qc && getComputedStyle(qc).display !== 'none' &&
          parseInt(input.value, 10) > 0) { card = cards[i]; break; }
    }
    if (!card) { done(); return; }
    var minus = card.querySelector('.quantity-btn.minus');
    if (!minus) { done(); return; }
    minus.click();
    setTimeout(function () { clearBox(done, guard + 1); }, 320);
  }

  /* Fixed-box mode: the preset is a 6-jar box, so make sure the 6-item
     box is the selected one before filling it. No-op on tiered pricing. */
  function selectPresetBox() {
    var opt = document.querySelector(
      '#bundlesuiteContainer .box-options-container .box-option[data-box-size="' + PRESET_SIZE + '"]');
    if (opt && !opt.classList.contains('selected')) opt.click();
  }

  /* A customer who pressed "Buy now" has already decided. Revealing the
     box-size picker and the autofill button mid-purchase re-opens a
     choice they just closed ("oh — I could pick different ones"), which
     is exactly the hesitation this one-click path exists to avoid. While
     the preset runs, the cart shows only the receipt half: the jars
     dropping into their slots and the toast naming each one. CSS keyed
     on this class does the hiding. */
  function setPresetRunning(on) {
    var c = document.getElementById('bundlesuiteContainer');
    if (c) c.classList.toggle('torshi-preset-running', !!on);
  }

  function runPreset(btn) {
    if (presetBusy) return;
    var plan = presetPlan();
    if (!plan.length) return;
    presetBusy = true;
    setPresetRunning(true);
    btn.classList.add('torshi-preset-busy');
    btn.textContent = 'Building your box…';
    /* Start from a clean box — otherwise whatever the customer already
       added is counted toward the preset and the result is a box that
       is neither theirs nor the preset. */
    allowCart();
    selectPresetBox();
    setTimeout(function () { clearBox(function () { fillPreset(btn, plan); }); }, 400);
  }

  /* Buy-now handoff: the box is full, so the app has enabled its own
     Checkout button — press it. The app owns cart creation and the
     redirect, so this stays correct if its checkout flow changes.
     Polls briefly because enabling happens on the app's own tick; if it
     never enables (e.g. stock ran out mid-fill), the button resets so
     the customer is never stranded on a dead label. */
  function goToCheckout(btn, needed, tries) {
    tries = tries || 0;
    var cta = document.querySelector('#bundlesuiteContainer .side-cart-checkout-cta button');
    var count = parseInt((document.querySelector('#bundlesuiteContainer .added-products-count') || {}).textContent, 10) || 0;
    /* NB: the CTA keeps a stale "requirements-not-met" class even when the
       box is full — the app's own click handler is the source of truth, so
       gate on the box actually being full instead of the class. */
    if (cta && !cta.disabled && count >= needed) {
      /* the app's checkout lands on /cart first; this flag makes the
         theme.liquid snippet on /cart bounce straight on to /checkout */
      try { sessionStorage.setItem('torshiBuyNow', '1'); } catch (e) {}
      cta.click();
      return;
    }
    if (tries < 40) { setTimeout(function () { goToCheckout(btn, needed, tries + 1); }, 250); return; }
    /* Checkout never opened — hand the cart back in full so the customer
       can finish by hand instead of staring at a half-hidden panel. */
    setPresetRunning(false);
    ensureAutofill();
    btn.classList.remove('torshi-preset-done');
    btn.textContent = 'Buy now — checkout didn\u2019t open, tap Checkout in your cart';
  }

  function fillPreset(btn, plan) {
    var totalJars = plan.reduce(function (s, p) { return s + p.qty; }, 0);
    var done = 0;
    var steps = [];
    plan.forEach(function (p) {
      steps.push({ handle: p.handle, action: 'add' });
      for (var q = 1; q < p.qty; q++) steps.push({ handle: p.handle, action: 'plus' });
    });

    function tick() {
      if (!steps.length) {
        btn.classList.remove('torshi-preset-busy');
        btn.classList.add('torshi-preset-done');
        btn.textContent = '✓ Box ready — taking you to checkout…';
        presetBusy = false;
        allowCart();
        goToCheckout(btn, totalJars);
        return;
      }
      var step = steps.shift();
      var card = cardByHandle(step.handle);
      if (card) {
        if (step.action === 'add') {
          var add = card.querySelector('.add-button');
          if (add && getComputedStyle(add).display !== 'none') {
            add.click();
          } else {
            var plusA = card.querySelector('.quantity-btn.plus');
            if (plusA) plusA.click();
          }
        } else {
          var plus = card.querySelector('.quantity-btn.plus');
          if (plus) plus.click();
        }
        done += 1;
        btn.textContent = 'Building your box… ' + done + '/' + totalJars;
      }
      setTimeout(tick, 550);
    }
    btn.textContent = 'Building your box… 0/' + totalJars;
    tick();
  }

  function toggleGrid(explicit) {
    var container = document.getElementById('bundlesuiteContainer');
    if (!container) return;
    var collapsed = container.classList.contains('torshi-grid-collapsed');
    var open = explicit === undefined ? collapsed : explicit;
    container.classList.toggle('torshi-grid-collapsed', !open);
    var link = document.querySelector('.torshi-customize-toggle');
    if (link) {
      link.innerHTML = open
        ? 'Hide the options ▴'
        : 'or customize your own box ▾';
    }
    if (open) {
      allowCart();
      var section = container.querySelector('.individual-products-section');
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      /* Hiding the options with an empty box: the cart is useless, hide
         it again. With jars in the box it stays. */
      var count = container.querySelector('.added-products-count');
      if (!count || !(parseInt(count.textContent, 10) > 0)) {
        container.classList.remove('torshi-cart-allowed');
      }
    }
  }

  function buildPresetCard() {
    if (document.querySelector('.torshi-preset')) return;
    var container = document.getElementById('bundlesuiteContainer');
    var anchorBlock = findCustomizeBlock();
    var wrapper = container ? container.querySelector('.main-product-content-container .main-wrapper') : null;
    var plan = presetPlan();
    /* wait for real tier data (thresholds AND their values), so the
       preset price is computed right */
    if (!container || !plan.length || !tiersReady()) return;
    if (!anchorBlock && !wrapper) return;

    var totalJars = plan.reduce(function (s, p) { return s + p.qty; }, 0);
    var subtotal = plan.reduce(function (s, p) { return s + p.qty * p.price; }, 0);
    var deal = dealForCount(totalJars, subtotal);
    var pct = deal.savingsPct;
    var discounted = deal.price;
    var img = container.querySelector('.product-card .product-card-image img');

    var card = document.createElement('div');
    card.className = 'torshi-preset';
    card.innerHTML =
      '<div class="torshi-preset-media">' +
      (img ? '<img src="' + img.src + '" alt="Torshi jars">' : '') +
      '</div>' +
      '<div class="torshi-preset-body">' +
      '<span class="torshi-preset-chip">★ Most popular</span>' +
      '<h3 class="torshi-preset-title">The Classic ' + totalJars + '</h3>' +
      '<p class="torshi-preset-sub">One jar of every flavour, doubled up on our bestsellers.</p>' +
      '<div class="torshi-preset-price">' +
      '<s>$' + subtotal.toFixed(2) + '</s> <strong>$' + discounted.toFixed(2) + '</strong>' +
      '<span class="torshi-preset-savechip">' + pct + '% off</span>' +
      '</div>' +
      '</div>' +
      '<div class="torshi-preset-actions">' +
      '<button type="button" class="torshi-preset-add">Buy now — ' + totalJars + ' jars</button>' +
      '<button type="button" class="torshi-customize-toggle">or customize your own box ▾</button>' +
      '</div>';

    if (anchorBlock) {
      anchorBlock.insertAdjacentElement('afterend', card);
    } else {
      wrapper.insertBefore(card, wrapper.firstChild);
    }

    card.querySelector('.torshi-preset-add').addEventListener('click', function () {
      runPreset(this);
    });
    card.querySelector('.torshi-customize-toggle').addEventListener('click', function () {
      toggleGrid();
    });

    /* The intro paragraph explains the box, but it sat between the
       gallery and the card and pushed the only buy button ~190px further
       down. It reads just as well underneath the card, where it answers
       "what am I buying" for anyone not already sold. */
    var meta = document.querySelector('.main-product-section .product__meta');
    if (meta) {
      var intro = null;
      [].forEach.call(meta.children, function (n) {
        if (intro) return;
        var cls = (n.className || '').toString();
        if (cls.indexOf('product__description') > -1 &&
            n.textContent.indexOf('Build your own box') > -1) intro = n;
      });
      if (intro) card.insertAdjacentElement('afterend', intro);
    }

    /* Arm A (default): grid collapsed. Arm B: ?arm=open keeps it open. */
    var arm = (window.location.search.match(/[?&]arm=(\w+)/) || [])[1];
    if (arm !== 'open') {
      container.classList.add('torshi-grid-collapsed');
    } else {
      card.querySelector('.torshi-customize-toggle').innerHTML = 'Hide the options ▴';
      allowCart();
    }
    ensureBuyBar();
  }

  /* ---- Sticky mobile buy bar ----
     One buy button on a 9,000px page means anyone convinced further down
     has to scroll back to the top to act. Once the Classic 6 card leaves
     the screen a slim bar takes its place, so the decision is always one
     tap away. It stands down whenever the real cart is on screen (that
     has its own Checkout) or while the preset is mid-flight. */
  var buyBarMq = window.matchMedia('(max-width: 959px)');

  function ensureBuyBar() {
    if (document.querySelector('.torshi-buybar')) return;
    var card = document.querySelector('.torshi-preset');
    if (!card) return;
    var bar = document.createElement('div');
    bar.className = 'torshi-buybar';
    bar.innerHTML =
      '<button type="button" class="torshi-buybar-btn">' +
      '<span class="torshi-buybar-label"></span>' +
      '<span class="torshi-buybar-price"></span>' +
      '</button>';
    document.body.appendChild(bar);
    bar.querySelector('.torshi-buybar-btn').addEventListener('click', function () {
      var real = document.querySelector('.torshi-preset-add');
      if (!real) return;
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      runPreset(real);
    });
    window.addEventListener('scroll', updateBuyBar, { passive: true });
    window.addEventListener('resize', updateBuyBar);
    buyBarMq.addEventListener('change', updateBuyBar);
    updateBuyBar();
  }

  function updateBuyBar() {
    var bar = document.querySelector('.torshi-buybar');
    var real = document.querySelector('.torshi-preset-add');
    if (!bar || !real) return;
    var container = document.getElementById('bundlesuiteContainer');
    var cartUp = container && container.classList.contains('torshi-cart-allowed');
    /* only once the real button has scrolled off the top */
    var past = real.getBoundingClientRect().bottom < 0;
    var show = buyBarMq.matches && past && !cartUp && !presetBusy;
    bar.classList.toggle('torshi-buybar-on', !!show);
    if (show) {
      var priceEl = document.querySelector('.torshi-preset-price strong');
      bar.querySelector('.torshi-buybar-label').textContent = real.textContent.replace(/\s*—.*$/, '');
      bar.querySelector('.torshi-buybar-price').textContent = priceEl ? priceEl.textContent : '';
    }
  }

  /* Keep the PDP "From $X / jar — save up to Y%" line in sync with the
     app's live tier config (works for both % and fixed-price tiers). */
  function refreshPdpPriceLine() {
    var line = document.querySelector('.torshi-price-line');
    if (!line || line.dataset.synced === '1' || !tiersReady()) return;
    var cards = inStockCards();
    if (!cards.length) return;
    var jar = parseFloat(((cards[0].querySelector('.product-price p') || {}).textContent || '').replace(/[^\d.]/g, '')) || 0;
    if (!jar) return;
    var bestPerJar = jar;
    var maxSave = 0;
    getTiers().forEach(function (t) {
      if (t.min > 0) {
        var sub = t.min * jar;
        var d = dealForCount(t.min, sub);
        if (d.price / t.min < bestPerJar) bestPerJar = d.price / t.min;
        if (d.savingsPct > maxSave) maxSave = d.savingsPct;
      }
    });
    line.innerHTML =
      'From <strong>$' + bestPerJar.toFixed(2) + '</strong> / jar' +
      (maxSave > 0 ? ' <span class="torshi-save-chip">Save up to ' + maxSave + '%</span>' : '');
    line.dataset.synced = '1';
  }

  /* If the card ever rendered before the tier percentages arrived,
     recompute the price line once real data is available. */
  function refreshPresetPrice() {
    var preset = document.querySelector('.torshi-preset');
    if (!preset || preset.dataset.priced === '1') return;
    var plan = presetPlan();
    if (!plan.length) return;
    var totalJars = plan.reduce(function (s, p) { return s + p.qty; }, 0);
    var subtotal = plan.reduce(function (s, p) { return s + p.qty * p.price; }, 0);
    var deal = dealForCount(totalJars, subtotal);
    var pct = deal.savingsPct;
    if (pct <= 0) return;
    var discounted = deal.price;
    var priceEl = preset.querySelector('.torshi-preset-price');
    if (priceEl) {
      priceEl.innerHTML =
        '<s>$' + subtotal.toFixed(2) + '</s> <strong>$' + discounted.toFixed(2) + '</strong>' +
        '<span class="torshi-preset-savechip">' + pct + '% off</span>';
      preset.dataset.priced = '1';
    }
  }

  /* Hover on a builder card shows the product's second image.
     Second images aren't in the widget DOM, so they're fetched once
     per product from the public /products/<handle>.js endpoint.
     Delegated listeners survive the widget's re-renders. */
  var secondImages = {};
  var hoverBound = false;
  function bindHoverSwap(container) {
    if (hoverBound) return;
    hoverBound = true;

    function cardImg(card) {
      return card.querySelector('.product-card-image img');
    }
    function swapTo(img, url) {
      if (!img.dataset.torshiOrigSrc) {
        img.dataset.torshiOrigSrc = img.src;
        if (img.srcset) {
          img.dataset.torshiOrigSrcset = img.srcset;
        }
      }
      img.removeAttribute('srcset');
      img.src = url;
    }
    function restore(img) {
      if (img.dataset.torshiOrigSrc) {
        img.src = img.dataset.torshiOrigSrc;
        if (img.dataset.torshiOrigSrcset) {
          img.srcset = img.dataset.torshiOrigSrcset;
        }
      }
    }

    container.addEventListener('mouseover', function (e) {
      var card = e.target.closest ? e.target.closest('.product-card') : null;
      if (!card) return;
      var handle = card.getAttribute('data-product-handle');
      var img = cardImg(card);
      if (!handle || !img) return;

      if (!(handle in secondImages)) {
        secondImages[handle] = null; // fetch in flight
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.images && d.images.length > 1) {
              var u = d.images[1];
              if (u.indexOf('//') === 0) u = 'https:' + u;
              u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=600';
              secondImages[handle] = u;
              var pre = new Image();
              pre.src = u;
              if (card.matches(':hover')) swapTo(cardImg(card), u);
            }
          })
          .catch(function () {});
      } else if (secondImages[handle]) {
        swapTo(img, secondImages[handle]);
      }
    });

    container.addEventListener('mouseout', function (e) {
      var card = e.target.closest ? e.target.closest('.product-card') : null;
      if (!card) return;
      if (e.relatedTarget && card.contains(e.relatedTarget)) return;
      var img = cardImg(card);
      if (img) restore(img);
    });
  }

  function apply() {
    ensureMount();
    patchPdp();
    patchCustomizeHeading();
    patchButtons();
    patchSectionTitles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  /* The widget mounts asynchronously and re-renders on state changes:
     poll until it appears, then keep the buttons patched. */
  var tries = 0;
  var poll = setInterval(function () {
    tries++;
    apply();
    var container = document.getElementById('bundlesuiteContainer');
    if (container || tries > 100) {
      clearInterval(poll);
      relocateBelowBuilder();
      if (container) {
        buildPresetCard();
        patchStepperLabels();
        patchBoxOptions();
        ensureAutofill();
        markPopularCard();
        relocateMobileHeader();
        syncCartAllowed();
        bindHoverSwap(container);
        new MutationObserver(function () {
          patchButtons();
          patchSectionTitles();
          patchStepperLabels();
          patchBoxOptions();
          ensureAutofill();
          markPopularCard();
          relocateMobileHeader();
          buildPresetCard();
          refreshPresetPrice();
          refreshPdpPriceLine();
          syncCartAllowed();
          ensureBuyBar();
          updateBuyBar();
        }).observe(container, { childList: true, subtree: true });
      }
    }
  }, 100);
})();


